import React, { useEffect, useMemo, useRef, useState } from 'react'
import { Button, Col, Form, Modal, Row, Tab, Tabs } from 'react-bootstrap';

import TableGrid from "../../../Components/common/TableGrid";
import { useSelector, useDispatch } from "react-redux";

import TableFilters from '../../../Components/common/TableGrid/TableFilters.js';
import { useTmpMgmtQuery, useToggleTemplateStatusMutation, useV2DropdownListQuery } from '../../../redux/services/SRC.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faEnvelope, faFileAlt, faGlobe, faPlus, faReply, faTasks } from '@fortawesome/free-solid-svg-icons';
import { CallApi, CommonModal } from '../../../Components/common/CommonFunctions.js';
import { ReactComponent as SaveIcon } from "../../../assets/images/save.svg";
import Select from 'react-select'
import { toast } from 'react-toastify';
import MessageBox from '../../../Components/common/MessageBox.js';
import TableTabs from '../../../Components/common/TableGrid/TableTabs.js';
import { clearSelectedRowsData, onTabChange } from '../../../redux/features/table/tableSlice.js';
import { ReactComponent as ArchiveIcon } from "../../../assets/images/slotplanning/archive_icon.svg";
import { ReactComponent as EditIcon } from "../../../assets/images/settings_icon/edit.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/images/settings_icon/delete.svg";
import { ReactComponent as User } from "../../../assets/images/icon_svg/user_history.svg";
import { ReactComponent as TaskCreator } from "../../../assets/images/icon_svg/task_creator.svg";
import { ReactComponent as Region } from "../../../assets/images/icon_svg/region.svg";
import ConfModal from '../../../Components/common/ConfModal.js';

const TemplateManager = () => {

    const isMounted = useRef(false);
    const dispatch = useDispatch();
    const quillRef = useRef(null);
    const [createModal, setCreateModal] = useState(false);
    const [activeTemplate, setActiveTemplate] = useState("task");
    const initFData = { name: '', subject: '', description: '', assign_to: 301 }
    const [formData, setFormData] = useState(initFData);
    const [rolestype, setRolestype] = useState([]);
    const [userList, setUserList] = useState([]);
    const [multiDropDown, setMultiDropDown] = useState([]);
    const [insertFields, setInsertFields] = useState([]);
    const [showInsertModal, setShowInsertModal] = useState(false);
    const [cursorPosition, setCursorPosition] = useState(null);
    const [modalConf, setModalConf] = useState(false)
    const [deleteId, setDeleteId] = useState()

    const templateList = []
    const handleTemplayeClick = (key) => {
        setActiveTemplate(key);
    };

    const tabsConfig = [
        { label: "Active", value: "1", paramKey: 'activity_status' },
        { label: "Archive", value: "0", paramKey: 'activity_status' },
    ];

    const iconMap = {
        63: <FontAwesomeIcon icon={faEnvelope} />,
        64: <FontAwesomeIcon icon={faFileAlt} />,
        65: <FontAwesomeIcon icon={faTasks} />,
        66: <FontAwesomeIcon icon={faGlobe} />,
        67: <FontAwesomeIcon icon={faReply} />,
        68: <FontAwesomeIcon icon={faBell} />
    };
    const fetchRoles = async (data) => {
        CallApi({
            endPoint: 'template/roles',
            method: 'GET',
            onSuccess: (res) => {
                if (res.data.response_code === 200) {
                    const dataWithIcons = res.data.response_data.map(item => ({
                        ...item,
                        icon: iconMap[item.value] || null
                    }));
                    setRolestype(dataWithIcons);
                    if (data) {
                        setFormData(data)
                    } else {
                        setFormData({ ...initFData, role: 65 })
                    }

                }
            },
            onError: (msg) => toast.error(msg)
        });
    };

    const fetchinsertData = async (mname) => {
        CallApi({
            endPoint: 'template/get-insert-fields',
            payload: { module: 72 },
            onSuccess: (res) => {
                if (res.data.response_code === 200) {
                    const innerData = res.data.response_data;
                    if (innerData.length) {
                        setInsertFields(res.data.response_data);
                    } else {
                        setInsertFields([]);
                    }
                } else {
                    setInsertFields([]);
                }
            },
            onError: (msg) => toast.error(msg)
        });
    };
    const fetchUser = () => {
        CallApi({
            endPoint: 'v2/service-recovery/assign-user-list',
            // payload: { service_recovery_id: detID.service_recovery_id },
            onSuccess: (res) => {
                if (res.data.response_code === 200) {
                    const innerData = res.data.response_data;
                    const assignUserOpt = [
                        { label: 'Unassign', value: '' },
                        ...(innerData || [])
                    ];
                    setUserList(assignUserOpt);
                } else {
                    toast.error(res.data.response_msg)
                }
            },
            onError: (msg) => toast.error(msg)
        });
    }

    useEffect(() => {
        if (isMounted.current) return;
        fetchUser()
        fetchinsertData();
        dispatch(onTabChange({ key: 'activity_status', value: "1" }));
        isMounted.current = true;
    }, [])

    const createTemplate = (data) => {
        setCreateModal(true)
        fetchRoles(data);
    }

    const { data } = useV2DropdownListQuery();
    useEffect(() => {
        if (data?.response_data) {
            setMultiDropDown(data.response_data);
        }
    }, [data]);

    const { pageDetails, filters, sortby, selectedRows, tab } = useSelector((state) => state.table);

    const columns = [
        {
            label: "", field: "actions", enableSearch: false, cls: 'tw-6',
            renderCell: (row) => (
                <div className="tb_grid_actions">
                    <EditIcon className="row_view" style={{ cursor: "pointer" }}
                        onClick={(e) => {
                            e.stopPropagation();
                            createTemplate(row)
                        }} />
                    <DeleteIcon className="row_msg" style={{ cursor: "pointer", marginLeft: "6px" }}
                        onClick={(e) => {
                            e.stopPropagation();
                            setDeleteId(row.id);
                            setModalConf(true)
                        }} />
                </div>
            ),
        },
        { label: "Template Name", field: "name", enableSearch: false, cls: 'tw-7' },
        ...(activeTemplate === 'task'
            ? [{ label: "Task Title", field: "title", enableSearch: false, cls: 'tw-8' },
            { label: "Default Assigned", field: "assigned", enableSearch: false, cls: 'tw-8' },
            { label: "Created On", field: "created_on", enableSearch: false },]
            : [{ label: "Created On", field: "created_on", enableSearch: false, cls: 'tw-8' },
            { label: "Email Subject", field: "subject", enableSearch: false },
            ]),

    ];

    const buildFilterParams = (filtersObj) => {
        const entries = Object.entries(filtersObj);
        const params = {};
        if (!entries.length) return params;
        entries.forEach(([field, value], index) => {
            params[`filtervalue${index}`] = value;
            params[`filtercondition${index}`] = "CONTAINS";
            params[`filteroperator${index}`] = 0;
            params[`filterdatafield${index}`] = field;
        });
        params.filterscount = entries.length;
        return params;
    };

    const queryParams = useMemo(() => {
        const filterParams = buildFilterParams(filters);
        const params = {
            ...filterParams,
            tab: activeTemplate,
            // activity_status: "0",
            pagenum: pageDetails.pagenum,
            pagesize: pageDetails.pagesize,
            recordstartindex: pageDetails.recordstartindex,
            recordendindex: pageDetails.recordendindex,
        };
        if (sortby?.sortdatafield) {
            params.sortdatafield = sortby.sortdatafield;
            params.sortorder = sortby.sortorder;
        }
        if (tab?.value && tab.key) {
            params[tab.key] = tab.value;
        }
        return params;
    }, [filters, pageDetails, sortby, activeTemplate, tab]);

    const { data: myData, isFetching, refetch } = useTmpMgmtQuery(queryParams, {
        skip: pageDetails.pagesize === 0,
        refetchOnMountOrArgChange: true,
    });

    // const bulkActions = tab?.value === "A"
    //     ? [{ label: "Archive", action: handleArchive, icon: ArchiveIcon }]
    //     : tab?.value === "R"
    //         ? [{ label: "Activate", action: handleArchive, icon: ArchiveIcon }]
    //         : [];

    const modalClose = () => {
        setCreateModal(false)
        setFormData(initFData);
    }

    const formChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }))
    }

    const addInsert = () => {
        // if (!formData.module) {
        //     toast.error('Please select module first')
        //     return;
        // }
        if (insertFields.length === 0) {
            toast.error('No Data available in this module');
            return;
        }
        if (quillRef.current) {
            const editor = quillRef.current.getEditor();
            const selection = editor.getSelection();
            setCursorPosition(selection ? selection.index : editor.getLength());
        }
        setShowInsertModal(true);
    }
    const [toggleTemplateStatus, { isLoading: archiveLoading }] = useToggleTemplateStatusMutation();

    const handleArchive = async (rows) => {
        try {
            const ids = rows.map((r) => r.id);
            const payload = {
                id: ids,
                activity_status: tab?.value == "1" ? 0 : 1,
            };
            await toggleTemplateStatus(payload).unwrap();
            toast.success("Status updated");
            refetch();
            dispatch(clearSelectedRowsData(true));
        } catch (err) {
            toast.error("Updation failed");
        }
    };
    const bulkActions = tab?.value == "1"
        ? [{ label: "Archive", action: handleArchive, icon: ArchiveIcon }]
        : tab?.value == "0"
            ? [{ label: "Activate", action: handleArchive, icon: ArchiveIcon }]
            : [];

    const handleSave = () => {
        let payLoad = {};
        if (Number(formData?.role) === 63) {
            const { title, assignment, ...rest } = formData;
            payLoad = rest;
        } else if (Number(formData?.role) === 65) {
            const { subject, ...rest } = formData;
            payLoad = rest;
        }

        CallApi({
            endPoint: 'template/add-update',
            payload: payLoad,
            onSuccess: (res) => {
                if (res.data.response_code === 200) {
                    refetch();
                    modalClose();
                    toast.success(res.data.response_msg)
                } else {
                    toast.error(res.data.response_msg)
                }
            },
            onError: (msg) => toast.error(msg)
        });
    };

    const extractVariables = (text) => {
        const matches = text.match(/{{(.*?)}}/g) || [];
        return matches.map(m => m.replace(/[{}]/g, ''));
    };
    const usedVariables = extractVariables(formData.description);

    const handleConfDelete = () => {
        CallApi({
            endPoint: 'template/delete-restore',
            payload: { id: deleteId },
            onSuccess: (res) => {
                if (res.data.response_code === 200) {
                    toast.success('Template Removed Successfully')
                    refetch()
                    setModalConf(false);
                } else {
                    toast.error(res.data.response_msg)
                }
            },
            onError: (msg) => toast.error(msg)
        });
    }

    return (
        <>
            {modalConf &&
                <ConfModal
                    header={`Delete Template`}
                    subHeader={`Are you sure you want to delete this Template?`}
                    modalConf={() => handleConfDelete()}
                    closeModal={() => setModalConf(false)}
                    primaryBtn='Delete'
                    secondaryBtn='Cancel'
                />
            }
            <div>
                <h4>Template Management</h4>
                <p>Manage templates for tasks and emails.</p>
            </div>
            <hr />
            <div className="d-flex align-items-center mb-3">
                <Button variant="primary createplan" onClick={() => createTemplate(null)}>
                    <FontAwesomeIcon icon={faPlus} /> Create Template
                </Button>

            </div>
            <div className="d-flex justify-content-between align-items-center mb-3">
                <Tabs id="template-tabs" activeKey={activeTemplate} onSelect={handleTemplayeClick} className="booking_tab">
                    <Tab eventKey="task" key="task"
                        title={
                            <span>
                                Task Template
                                <span className="rabadge badge bg-primary ms-2 ssss">
                                    {myData?.totalTask}
                                </span>
                            </span>
                        }
                    />
                    <Tab eventKey="email" key="email"
                        title={
                            <span>
                                Email Template
                                <span className="rabadge badge bg-primary ms-2 ssss">
                                    {myData?.totalEmail}
                                </span>
                            </span>
                        }
                    />
                    
                </Tabs>
                <TableTabs tabs={tabsConfig} />
            </div>
            <div className='setting_table'>
                <TableGrid
                    columns={columns}
                    rows={myData?.Rows}
                    checkboxSelection={true}
                    totalRecords={myData?.TotalRows || 0}
                    onClickRow={(row) => {
                        console.log("Clicked Row:", row);
                    }}
                    loading={isFetching}
                    bulkActions={bulkActions}
                />
            </div>
            {/* {console.log('formData', formData)} */}
            {createModal &&
                <CommonModal
                    show={createModal}
                    onHide={modalClose}
                    title='Create Template'
                    subTitle='Define a reusable task or email template'
                    className='modal_bgw primary_modal modal_width_690'
                    footer={
                        <div className='d-flex justify-content-between w-100'>
                            <div></div>
                            <Button variant="primary" className='defult_save' onClick={handleSave}>
                                <SaveIcon /> Save
                            </Button>
                        </div>
                    }>
                    <Form.Group className='tw-50'>
                        <Form.Label>Template Type <span className='red'>*</span></Form.Label>
                        <Select
                            options={rolestype}
                            onChange={(selected) => setFormData(prev => ({ ...prev, role: selected.value })
                            )}
                            placeholder="Select roles"
                            className=''
                            name="role"
                            value={rolestype?.find(tp => tp.value == formData.role) || null}
                            // isDisabled={editId && formData.role_type}
                            // formatOptionLabel={(option) => (
                            //     <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            //         {option.icon}
                            //         <span>{option.label}</span>
                            //     </div>
                            // )}
                        />
                    </Form.Group>
                    <hr/>
                    <Form.Group className="mb-2">
                        <Form.Label>Template Name <span className='red'>*</span></Form.Label>
                        <Form.Control type='text' name='name' value={formData.name || ''} onChange={formChange} placeholder='Template Name' />
                    </Form.Group>
                    <Form.Group className="mb-2">
                        <Form.Label>Task Title <span className='red'>*</span></Form.Label>
                        <Form.Control type='text' name='title' value={formData.title || ''} onChange={formChange} placeholder='Task Title' />
                    </Form.Group>

                    <Form.Group as={Row} className="mb-2">
                        <Col sm={6} className="pe-0">
                            <Form.Label>Priority <span className='red'>*</span></Form.Label>
                            <Select
                                options={multiDropDown?.priority_type}
                                onChange={(selected) => setFormData(prev => ({ ...prev, priority_id: selected.value })
                                )}
                                placeholder="Priority"
                                className=''
                                name="priority_id"
                                value={multiDropDown?.priority_type?.find(tp => tp.value == formData.priority_id) || null}
                            />
                        </Col>

                        <Col sm={formData?.due_in === 300 ? 3 : 6}>
                            <Form.Label>Due In <span className='red'>*</span></Form.Label>
                            <Select
                                options={multiDropDown?.task_due_in}
                                onChange={(selected) => setFormData(prev => ({ ...prev, due_in: selected.value })
                                )}
                                placeholder="Select Duration"
                                className=''
                                name="role"
                                value={multiDropDown?.task_due_in?.find(tp => tp.value == formData.due_in) || null}
                            />

                        </Col>
                        {formData?.due_in === 300 &&
                            <Col sm={3} className='custom_days' >
                                <>
                                    <Form.Control className='w-50 d-inline' type='text' name='custom_due_in' value={formData.custom_due_in || ''} onChange={formChange} /> <span>Day(s)</span>
                                </>
                            </Col>
                        }
                    </Form.Group>

                    {/* <Form.Group className='d-flex justify-content-between tw-50'>
                        <div className={Number(formData?.role) === 63 ? 'w-100' : 'tw-46'}>
                            <Form.Label>{Number(formData?.role) === 63 ? 'Email Subject' : Number(formData?.role) === 66 ? 'Task Title' : ''}</Form.Label>
                            {Number(formData?.role) === 63 &&
                                <Form.Control
                                    type='text'
                                    name={Number(formData?.role) === 63 ? 'subject' : 'title'}
                                    value={(Number(formData?.role) === 63 ? formData.subject : formData.title) || ''}
                                    onChange={formChange}
                                />
                            }
                        </div>
                        {Number(formData?.role) === 65 &&
                            <div className='tw-46'>
                                <Form.Label>Default Assignment</Form.Label>
                                <Form.Control type='text' name='assignment' value={formData.assignment || ''} onChange={formChange} />
                            </div>
                        }
                    </Form.Group> */}
                    <div className='task_assign'>
                        <Form.Label className='d-block'>Default Assignment <span className='red'>*</span></Form.Label>
                        <ul>
                            {multiDropDown?.task_assignment?.map((a, index) => (
                                <li
                                    key={a.value + '_' + index}
                                    onClick={() => setFormData(prev => ({ ...prev, assign_to: a.value }))}
                                    className={a.value === formData?.assign_to ? 'active' : ''}
                                >
                                    {a.value === 302 && <TaskCreator/>}
                                    {a.value === 303 && <User/>}
                                    {a.value === 304 && <Region/>}

                                    {a.label}
                                </li>
                            ))}
                            {/* <li onClick={() => setFormData(prev => ({ ...prev, assign_to: 301 }))} className='active' >Unassigned</li>
                            <li onClick={() => setFormData(prev => ({ ...prev, assign_to: 302 }))}>Task Creator</li>
                            <li onClick={() => setFormData(prev => ({ ...prev, assign_to: 303 }))}>User</li>
                            <li onClick={() => setFormData(prev => ({ ...prev, assign_to: 304 }))}>Record Region</li> */}
                        </ul>
                    </div>
                    {formData?.assign_to === 303 &&
                        <Form.Group className='tw-50 mb-2'>
                            <Select
                                options={userList}
                                onChange={(selected) => setFormData(prev => ({ ...prev, assign_type: selected.value })
                                )}
                                placeholder="Assign User"
                                className=''
                                name="role"
                                value={userList?.find(tp => tp.value == formData.assign_type) || null}
                            />
                        </Form.Group>
                    }
                    <Form.Group>
                        <Form.Label>{formData?.role === 63 ? 'Email' : formData?.role === 65 ? 'Task' : ''} Description</Form.Label>
                        {/* <Form.Control
                            as="textarea"
                            name='description'
                            type="text"
                            rows={5}
                            style={{ resize: 'none' }}
                            value={formData?.description || ''}
                            onChange={formChange}
                        /> */}
                        <MessageBox
                            divCls='mt-1'
                            message_area="template"
                            value={formData.description || ''}
                            onMessageChange={content => setFormData(prev => ({ ...prev, description: content }))}
                        />
                        {/* <span onClick={addInsert}>{'{ }'}</span> */}
                    </Form.Group>
                </CommonModal>
            }
            {showInsertModal &&
                <CommonModal
                    show={showInsertModal}
                    onHide={() => setShowInsertModal(false)}
                    title='Insert Field'
                    subTitle='Click on a field to insert in template:'
                    className='modal_bgw primary_modal modal_width_690'
                    footer={
                        <div className='d-flex justify-content-between w-100'>
                            <div></div>
                            <Button variant="secondary" onClick={() => setShowInsertModal(false)}>
                                Close
                            </Button>
                        </div>
                    }>
                    {insertFields && insertFields.length > 0 ? (

                        <div className="insert_field">
                            {insertFields.map((sub, index) => (
                                <div key={index} className="">
                                    <h4>{sub.label}</h4>
                                    <div className="d-flex flex-wrap gap-2 mb-2">
                                        {sub?.data?.map((field, index) => {
                                            const isUsed = usedVariables.includes(field.value);
                                            return (
                                                <Button
                                                    variant='contained'
                                                    className={`text-start outline_btn_gray ${isUsed ? 'insert_select' : ''}`}
                                                    onClick={() => {
                                                        if (quillRef.current) {
                                                            const editor = quillRef.current.getEditor();
                                                            const position = cursorPosition !== null ? cursorPosition : editor.getLength();
                                                            const fieldText = `{{${field.value}}} `;

                                                            // Get current content and insert at position
                                                            const delta = editor.getContents();
                                                            editor.deleteText(position, 0);
                                                            editor.insertText(position, fieldText);

                                                            // Update cursor position for next insert
                                                            const newPosition = position + fieldText.length;
                                                            editor.setSelection(newPosition, 0);
                                                            setCursorPosition(newPosition);

                                                            // Focus back to editor
                                                            editor.focus();
                                                        } else {
                                                            const currentContent = formData.description || '';
                                                            setFormData(prev => ({
                                                                ...prev,
                                                                description: currentContent + `{{${field.value}}} `
                                                            }));
                                                        }
                                                    }}
                                                >
                                                    {field.label || field.value}
                                                </Button>
                                            )
                                        })}
                                    </div>

                                </div>
                            ))}
                        </div>

                    ) : (
                        <p>No insert fields available.</p>
                    )}
                </CommonModal>
            }
            {/* <Modal show={showInsertModal} onHide={() => setShowInsertModal(false)} centered size="lg" style={{ zIndex: 9999 }} className='modal_bgw primary_modal'>
                <Modal.Header closeButton>
                    <Modal.Title>Insert Field<p>Click on a field to insert in template:</p></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {insertFields && insertFields.length > 0 ? (
                        <div className="insert-fields-container serv_inser_field">
                            <div className="row">
                                {insertFields.map((field, index) => (
                                    <div key={index} className="col-md-4 mb-2">
                                        <Button
                                            variant="outline-secondary"
                                            className="w-100 text-start insert_btn"
                                            onClick={() => {
                                                if (quillRef.current) {
                                                    const editor = quillRef.current.getEditor();
                                                    const position = cursorPosition !== null ? cursorPosition : editor.getLength();
                                                    const fieldText = `{{${field.value}}} `;

                                                    // Get current content and insert at position
                                                    const delta = editor.getContents();
                                                    editor.deleteText(position, 0);
                                                    editor.insertText(position, fieldText);

                                                    // Update cursor position for next insert
                                                    const newPosition = position + fieldText.length;
                                                    editor.setSelection(newPosition, 0);
                                                    setCursorPosition(newPosition);

                                                    // Focus back to editor
                                                    editor.focus();
                                                } else {
                                                    const currentContent = formData.description || '';
                                                    setFormData(prev => ({
                                                        ...prev,
                                                        description: currentContent + `{{${field.value}}} `
                                                    }));
                                                }
                                            }}
                                        >
                                            {field.label || field.value}
                                        </Button>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ) : (
                        <p>No insert fields available.</p>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowInsertModal(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal> */}
        </>
    )
}

export default TemplateManager